import React, { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { useIntl } from 'react-intl'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { get2FaDetails, setup2FA, verifySetup2FA } from '../../auth/core/_requests'
import { toast } from 'react-toastify'
import { QRCodeCanvas } from 'qrcode.react'
import Skeleton from 'react-loading-skeleton'
import Iccopy from '../../../../media/EarlyAccess/ic-copy.svg'

const TwoFAModal = ({ isActive, setIsActive }: any) => {
  const { formatMessage } = useIntl()
  const [currentDocumentStep, setCurrentDocumentStep] = useState(1)
  const [selectedOption, setSelectedOption] = useState<string>('authenticator-app')
  const [isLoading, setIsLoading] = useState(false) //eslint-disable-line
  const [qrUrl, setQrUrl] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [backupCodes, setBackupCodes] = useState<any>() //eslint-disable-line
  const [codeError, setCodeError] = useState(false)
  const otpAuthUrl = localStorage.getItem('otpAuthUrl') || ''
  const backupCode = localStorage.getItem('2fa-backup-codes') || ''
  const base32 = localStorage.getItem('base32') || ''
  const codes: string[] = backupCode ? JSON.parse(backupCode) : []
  const [qrCode, setQrCode] = useState<string>('')
  const [checked, setChecked] = useState(false)

  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=600,height=600')

    if (!printWindow) return

    const htmlContent = `
      <html>
        <head>
          <title>2FA Backup Codes</title>
          <style>
            body { font-family: sans-serif; padding: 20px; }
            h2 { margin-bottom: 10px; }
            ul { list-style: none; padding-left: 0; }
            li { margin: 5px 0; font-size: 18px; }
          </style>
        </head>
        <body>
          <h2>2FA Backup Codes</h2>
          <ul>
            ${codes.map((code) => `<li>${code}</li>`).join('')}
          </ul>
          <script>
            window.onload = function () {
              window.print();
              window.onafterprint = function () { window.close(); };
            };
          </script>
        </body>
      </html>
    `

    printWindow.document.write(htmlContent)
    printWindow.document.close()
  }
  const [btnisLoading, btnsetIsLoading] = useState(false);

  const nextStep = async () => {
    if (currentDocumentStep < 3) {
      if (currentDocumentStep + 1 === 2) {
        btnsetIsLoading(true);
        await createSetup2FA();
        btnsetIsLoading(false);
      }
      if (currentDocumentStep + 1 === 3) {
        if (!code?.trim()) {
          setCodeError(true);
          return;
        } else {
          setCodeError(false);
          btnsetIsLoading(true);
          await verifySetup2Fa();
          btnsetIsLoading(false);
        }
      }
      if (currentDocumentStep < 2) {
        setCurrentDocumentStep((prev) => prev + 1);
      }
    }
  };
  const prevStep = async () => {
    if (currentDocumentStep > 1) {
      setCurrentDocumentStep((prev) => prev - 1)
    }
  }

  const createSetup2FA = async () => {
    setIsLoading(true)
    try {
      const {
        data: { success, data },
      } = await setup2FA()
      if (success) {
        setQrUrl(data.otpauthUrl)
        setQrCode(data.base32)
        localStorage.setItem('2fa-backup-codes', JSON.stringify(data.backupCodes))
        localStorage.setItem('otpAuthUrl', data.otpauthUrl)
        localStorage.setItem('base32', data.base32)
      } else {
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  const verifySetup2Fa = async () => {
    if (!code) return
    try {
      const {
        data: { success, errors },
      } = await verifySetup2FA(code)
      if (success) {
        setCurrentDocumentStep((prev) => prev + 1)
        // download2FaBackupCodes()
        toast.success(formatMessage({ id: 'Verification Code Verified' }))
        setCode('')
        setChecked(false)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  // const download2FaBackupCodes = async () => {
  //   try {
  //     const response = await downloadBackupCodes(); // axios with responseType: 'blob'

  //     if (response?.status === 200) {
  //       toast.success(formatMessage({ id: 'downloading backups...' }));
  //       const textContent = response.data.body;
  //       const blob = new Blob([textContent], { type: 'text/plain' });
  //       const url = window.URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', 'backup-codes.txt');
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       window.URL.revokeObjectURL(url); // free up memory
  //     } else {
  //       toast.error('Failed to download backup codes');
  //     }
  //   } catch (err: any) {
  //     console.error(err);
  //     toast.error('Something went wrong while downloading backup codes');
  //   }
  // };

  const download2FaBackupCodes = () => {
    if (!backupCode) return toast.error('No backup codes found')

    const blob = new Blob([codes.join('\n')], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Recordskeeper-ai-2fa-backup-codes.txt')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    // Optional: Clean up
    // localStorage.removeItem('2fa-backup-codes')
  }

  const get2FADetails = async () => {
    try {
      const {
        data: { success, data, errors },
      } = await get2FaDetails()
      if (success) {
        setBackupCodes(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    get2FADetails()
  }, [currentDocumentStep]) // eslint-disable-line react-hooks/exhaustive-deps

  const removeLocalStorage = () => {
    setCurrentDocumentStep(1)
    setCode('')
    setChecked(false)
    localStorage.removeItem('2fa-backup-codes')
    localStorage.removeItem('otpAuthUrl')
    localStorage.removeItem('base32')
  }

  return (
    <Form>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
          removeLocalStorage()
        }}
        size='lg'
        fullscreen
      >
        <Modal.Header closeButton={checked}>
          <h2>{formatMessage({ id: 'Enable 2-Factor Authentication' })}</h2>
        </Modal.Header>
        <Modal.Body
          className='container'
          style={{
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <div
            className='stepper stepper-pills stepper-column d-flex flex-column'
            id='kt_create_account_stepper'
          >
            <div className='d-flex justify-content-start flex-column w-100'>
              <div className='py-4 px-0 d-flex justify-content-start'>
                <div
                  className='d-flex gap-12 align-items-center'
                  style={{
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  {[1, 2, 3, 4].map((step) => {
                    return (
                      <div
                        key={step}
                        className={`stepper-item ${currentDocumentStep === step ? 'current' : ''
                          } custom-marign-right`}
                        style={{ display: 'inline-block' }}
                      >
                        <div className='stepper-wrapper'>
                          {step === 1 && (
                            <div className='stepper-icon w-40px h-40px'>
                              <i className='stepper-check'></i>
                              <span className='stepper-number'>{step}</span>
                            </div>
                          )}
                          {step === 2 && (
                            <div className='stepper-icon w-40px h-40px'>
                              <i className='stepper-check'></i>
                              <span className='stepper-number'>{step}</span>
                            </div>
                          )}
                          {step === 3 && (
                            <div className='stepper-icon w-40px h-40px'>
                              <i className='stepper-check'></i>
                              <span className='stepper-number'>{step}</span>
                            </div>
                          )}

                          <div className='stepper-label'>
                            <h3 className='stepper-title fw-semibold font-size-13'>
                              {step === 1 && (
                                <>
                                  {formatMessage({
                                    id: 'Step 1',
                                  })}
                                </>
                              )}
                              {step === 2 && (
                                <>
                                  {formatMessage({
                                    id: 'Step 2',
                                  })}
                                </>
                              )}
                              {step === 3 && (
                                <>
                                  {formatMessage({
                                    id: 'Step 3',
                                  })}
                                </>
                              )}
                              {/* {step === 4 && (
                                <>
                                  {formatMessage({
                                    id: 'Step 4',
                                  })}
                                </>
                              )} */}
                            </h3>
                            <div className='stepper-desc font-size-12'>
                              {step === 1 && (
                                <>
                                  {formatMessage({
                                    id: 'Method',
                                  })}
                                </>
                              )}
                              {step === 2 && (
                                <>
                                  {formatMessage({
                                    id: 'Register',
                                  })}
                                </>
                              )}
                              {/* {step === 3 && (
                                <>
                                  {formatMessage({
                                    id: 'Verification',
                                  })}
                                </>
                              )} */}
                              {step === 3 && (
                                <>
                                  {formatMessage({
                                    id: 'Backup Code',
                                  })}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>

            <div className='d-flex flex-column justify-content-between'>
              <div className=''>
                {/* Step 1  */}
                {currentDocumentStep === 1 && (
                  <>
                    <div className='w-100 my-4'>
                      <InfoCard2
                        title={formatMessage({
                          id: 'Enable 2-Factor Authentication for Enhanced Security',
                        })}
                        desc={formatMessage({
                          id: 'This wizard will guide you through enabling 2-Factor Authentication (2FA) to strengthen your account security and protect it from unauthorized access. Please select a 2FA method from the options below and follow the on-screen instructions to complete the setup.',
                        })}
                        slug={`https://help.recordskeeper.ai/en/articles/10568418-how-to-enable-two-factor-authentication-2fa-on-recordskeeper-a`}
                        className='w-100 mb-0'
                      />
                    </div>
                    <h1 className='font-size-16 mb-4'>
                      {formatMessage({ id: 'Choose Verification Method for 2FA' })}
                      <ToolTipUIForModal tooltipText='Choose Verification Method for 2FA' />
                    </h1>
                    <div>
                      <div
                        className={`d-flex gap-4 border border-2 p-4 mb-4 align-items-center ${selectedOption === 'Personal' ? 'border-primary' : ''
                          }`}
                        onClick={() => setSelectedOption('authenticator-app')}
                      >
                        {' '}
                        <input
                          type='radio'
                          className='form-check-input'
                          checked={selectedOption === 'authenticator-app'}
                          onChange={() => setSelectedOption('authenticator-app')}
                        />{' '}
                        <img
                          alt='Logo'
                          src={toAbsoluteUrl('/media/auth/ic-authenticator-app.svg')}
                          height={32}
                          width={32}
                        />
                        <div className='d-flex flex-column'>
                          <h1 className='font-size-14'>
                            {formatMessage({ id: 'Authenticator App' })}{' '}
                            <span className='badge bg-primary bg-opacity-25 text-primary ms-2'>
                              {formatMessage({ id: 'Recommended' })}
                            </span>
                          </h1>

                          <p className='m-0'>
                            {formatMessage({
                              id: `Google Authenticator, Authy, or any other 2FA/MFA/Authenticator App`,
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Step 2  */}
                {currentDocumentStep === 2 && (
                  <>
                    <div className='w-100 my-4'>
                      <InfoCard2
                        title={formatMessage({
                          id: 'Enable 2-Factor Authentication for Enhanced Security',
                        })}
                        desc={formatMessage({
                          id: 'This wizard will guide you through enabling 2-Factor Authentication (2FA) to strengthen your account security and protect it from unauthorized access. Please select a 2FA method from the options below and follow the on-screen instructions to complete the setup.',
                        })}
                        slug={`https://help.recordskeeper.ai/en/articles/10568418-how-to-enable-two-factor-authentication-2fa-on-recordskeeper-a`}
                        className='w-100 mb-0'
                      />
                    </div>
                    <div className='d-flex flex-column align-items-center justify-content-center'>
                      {qrUrl ? (
                        isLoading ? (
                          <Skeleton
                            height={256}
                            width={256}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-4'
                          />
                        ) : (
                          <QRCodeCanvas
                            value={qrUrl || otpAuthUrl}
                            size={256}
                            level='H'
                            includeMargin={true}
                          />
                        )
                      ) : (
                        <Skeleton
                          height={256}
                          width={256}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          className='mb-4'
                        />
                      )}
                      <h1 className='font-size-16 mt-4'>
                        {formatMessage({ id: 'Scan QR Code using the Authenticator App' })}
                      </h1>
                      <p>
                        {formatMessage({
                          id: 'Open Authenticator App and Scan the QR Code',
                        })}
                      </p>

                      <div className='separator separator-content my-4'>
                        <span className='fw-semibold fs-6 tect-muted m-0'>or</span>
                      </div>
                      <p className='m-0 mb-2'>
                        {formatMessage({
                          id: 'Unable to scan? You can use the to manually configure your authenticator app.',
                        })}
                      </p>

                      <p className='m-0 mb-4'>
                        {' '}
                        {formatMessage({
                          id: 'Use below two-factor secret',
                        })}
                      </p>
                      <div className='d-flex gap-2 p-2 bg-secondary rounded-2 align-items-center w-100 w-md-50 justify-content-between'>
                        {isLoading ? (
                          <Skeleton
                            height={24}
                            width="100%"
                            containerClassName='w-100 m-0 p-0'
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        ) : (
                          <h1 className='font-size-14 m-0 px-2'>{qrCode || base32}</h1>
                        )}
                        <span
                          className={`px-2 cursor-pointer m-0 ${isLoading ? 'd-none' : ''}`}
                          onClick={() => {
                            navigator.clipboard.writeText(`${qrCode || base32}`)
                            toast.success(formatMessage({ id: 'Copied Successfully' }))
                          }}
                        >
                          <img src={Iccopy} alt='' />
                        </span>
                      </div>
                    </div>

                    <div
                      className='d-block mt-6 w-md-50 w-100'
                      style={{ margin: 'auto' }}
                    >
                      <label
                        className='form-label font-size-13 text-dark text-capitalize d-flex flex-md-row align-items-md-center'
                        htmlFor='kt_login_toc_agree'
                      >
                        {formatMessage({
                          id: '6 Digit Verification Code*',
                        })}{' '}
                        <ToolTipUIForModal tooltipText='Please enter the 6-digit verification code generated on your authentication app.' />
                      </label>
                      <div className='w-100'>
                        <input
                          value={code}
                          onChange={(e) => {
                            const value = e.target.value;
                            setCode(value);
                          }}
                          maxLength={6}
                          className={`bg-body form-control form-control-flush ps-4 rounded-2 font-size-13 font-weight-400 height-36 border ${codeError ? 'border-danger' : ''}`}
                          placeholder="Enter Code"
                        />
                        {codeError && (
                          <div className='text-danger font-size-12 mt-1'>
                            Please enter verification code.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {/* Step 3  */}
                {/* {currentDocumentStep === 3 && (
                  <>
                    <div className='w-100 my-4'>
                      <InfoCard2
                        title={formatMessage({
                          id: 'Enable 2-Factor Authentication for Enhanced Security',
                        })}
                        desc={formatMessage({
                          id: 'This wizard will guide you through enabling 2-Factor Authentication (2FA) to strengthen your account security and protect it from unauthorized access. Please select a 2FA method from the options below and follow the on-screen instructions to complete the setup.',
                        })}
                        slug={`https://help.recordskeeper.ai/en/articles/10568418-how-to-enable-two-factor-authentication-2fa-on-recordskeeper-a`}
                        className='w-100 mb-0'
                      />
                    </div>
                    <div className='d-flex flex-column gap-4'>
                      <div>
                        <h1 className='font-size-16'>
                          {formatMessage({ id: 'Verify 2-Factor Authentication' })}
                        </h1>
                        <p className='text-muted mb-0'>
                          {formatMessage({
                            id: 'Enter code that is being generated from authenticator app to make sure everything works.',
                          })}
                        </p>
                      </div>
                      <div className='w-md-50 w-100'>
                        <input
                          value={code}
                          onChange={(e) => {
                            setCode(e.target.value)
                            if (codeError) setCodeError(false)
                          }}
                          className='bg-body form-control form-control-flush ps-4 rounded-2 font-size-13 font-weight-400 height-36 border'
                          placeholder='Enter Code'
                        />
                        {codeError && (
                          <div className='text-danger font-size-12 mt-1'>
                            Please provide the code.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )} */}

                {/* Step 4  */}
                {currentDocumentStep === 3 && (
                  <>
                    <div className='w-100 my-4'>
                      <InfoCard2
                        title={formatMessage({
                          id: 'Enable 2-Factor Authentication for Enhanced Security',
                        })}
                        desc={formatMessage({
                          id: 'This wizard will guide you through enabling 2-Factor Authentication (2FA) to strengthen your account security and protect it from unauthorized access. Please select a 2FA method from the options below and follow the on-screen instructions to complete the setup.',
                        })}
                        slug={`https://help.recordskeeper.ai/en/articles/10568418-how-to-enable-two-factor-authentication-2fa-on-recordskeeper-a`}
                        className='w-100 mb-0'
                      />
                    </div>
                    <div className='d-flex justify-content-center'>
                      <div className='d-flex flex-column align-items-center justify-content-center gap-4 w-md-50 w-100'>
                        <h1 className='font-size-16'>
                          {formatMessage({ id: 'Backup Verification codes' })}
                        </h1>
                        <p className='text-center mb-0'>
                          {formatMessage({
                            id: `With 2FA enabled, you'll need these backup codes if you ever lose your device. Without your device or a backup code, you'll need to contact your account’s administrator to help them recover your account`,
                          })}
                        </p>
                        <p className='text-center mb-0'>
                          {formatMessage({
                            id: `We recommend you print them and keep them in a safe place`,
                          })}
                        </p>
                        {isLoading ? (
                          <div className='d-flex gap-6 flex-wrap justify-content-center'>
                            {Array(10)
                              .fill(null)
                              .map((_, index) => (
                                <Skeleton
                                  height={32}
                                  width={150}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                // className='mb-4'
                                />
                              ))}
                          </div>
                        ) : (
                          <div className='d-flex gap-6 flex-wrap justify-content-center'>
                            {codes &&
                              codes?.length > 0 &&
                              codes?.map((code: string, index: number) => (
                                <h1
                                  key={index}
                                  className='p-2 bg-secondary font-size-16 fw-semibold text-center mb-0 rounded'
                                  style={{ minWidth: '150px' }}
                                >
                                  {code}
                                </h1>
                              ))}
                          </div>
                        )}
                        <div className='d-flex gap-2 flex-column w-md-auto w-100 mt-4'>
                          <div className='d-flex flex-md-row flex-column justify-content-center gap-6 w-md-auto w-100'>
                            <button
                              className='btn btn-outline-primary w-md-auto w-100 custom-button-property'
                              onClick={handlePrint}
                            >
                              {formatMessage({ id: 'Print' })}
                            </button>
                            <button
                              className='btn bg-primary text-white w-md-auto w-100 custom-button-property'
                              onClick={() => download2FaBackupCodes()}
                            >
                              {formatMessage({ id: 'Download' })}
                            </button>
                          </div>
                        </div>

                        <label className='form-check mt-4'>
                          <input
                            type='checkbox'
                            className='form-check-input'
                            checked={checked}
                            onChange={(e) => setChecked(e.target.checked)}
                          />
                          <span className='form-check-label'>
                            {formatMessage({ id: 'I have downloaded & securely stored the backup code' })}
                          </span>
                        </label>

                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className='container px-0'>
          <div className='d-flex flex-md-row flex-column justify-content-md-end justify-content-center gap-3 w-100'>
            {currentDocumentStep > 1 && currentDocumentStep < 3 ? (
              <div className='order-md-1 order-2'>
                <button
                  type='button'
                  className='btn bg-light text-muted custom-button-property w-100'
                  onClick={prevStep}
                >
                  {formatMessage({ id: 'Back' })}
                </button>
              </div>
            ) : currentDocumentStep < 3 ? (
              <div className='order-md-1 order-2'>
                <button
                  type='button'
                  className='btn bg-light text-muted custom-button-property w-100'
                  onClick={() => {
                    setIsActive()
                    removeLocalStorage()
                  }}
                >
                  {formatMessage({ id: 'Cancel' })}
                </button>
              </div>
            ) : null}

            <div className='order-md-2 order-1'>
              {currentDocumentStep < 3 ? (
                <button
                  type="button"
                  className="btn bg-primary text-white custom-button-property w-100"
                  onClick={nextStep}
                  disabled={btnisLoading}
                >
                  {btnisLoading ? 'Please wait...' : formatMessage({ id: 'Next' })}
                </button>
              ) : (
                <button
                  type='submit'
                  className='btn bg-primary text-white custom-button-property w-100 '
                  onClick={() => {
                    setIsActive(false)
                    removeLocalStorage()
                  }}
                  disabled={!checked}
                >
                  <span className='indicator-label font-size-13 p-0'>
                    {formatMessage({ id: 'Close' })}
                  </span>
                </button>
              )}
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </Form>
  )
}

export default TwoFAModal
